/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/components/sap-sf-ec/SapSfEcInboundConfigEditDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const SapSfEcInboundConfigEditDialogTestIds = {
  btnCancelSapSfEcConfig: "btn-cancel-sap-sf-ec-config",
  btnSaveSapSfEcConfig: "btn-save-sap-sf-ec-config",
  selectSapSfEcAuthType: "select-sap-sf-ec-auth-type",
  selectSapSfEcDatetimeFormat: "select-sap-sf-ec-datetime-format"
} as const;
